import React from 'react'
import PropTypes from 'prop-types'
import { Row, H2, Subheading, BillboardText } from '@fs/zion-ui'
import { ContentCheck } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import {
  IN_PROGRESS_COLOR,
  DISABLED_BACKGROUND_COLOR,
  DISABLED_FOREGROUND_COLOR,
  DISABLED_TEXT_COLOR,
} from '../../shared/utils/panelConstants'

/**
 * ReviewCardHeader
 *
 * Displays the title and subheading for the Review Card. Icon background color reflects state:
 *  - Gray: Not active (pending state).
 *  - Yellow: Active (ready to review).
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.active=false] Indicates if the card is active.
 * @returns {JSX.Element}
 */
function ReviewCardHeader({ active = false }) {
  const [t] = useTranslation()
  const iconColor = active ? IN_PROGRESS_COLOR : DISABLED_BACKGROUND_COLOR

  return (
    <Row gutters="xxs" alignItemsY="middle">
      <ContentCheck size="sm" background={iconColor} color={active ? undefined : DISABLED_FOREGROUND_COLOR} />
      <BillboardText
        primaryColor={active ? undefined : DISABLED_TEXT_COLOR}
        secondaryColor={active ? undefined : DISABLED_TEXT_COLOR}
      >
        <H2 size="H5">
          {t('review-card.title', 'Review')}
          <Subheading>{t('review-card.subheading', 'Confirm Details and Add Name')}</Subheading>
        </H2>
      </BillboardText>
    </Row>
  )
}

ReviewCardHeader.propTypes = {
  active: PropTypes.bool,
}

ReviewCardHeader.defaultProps = {
  active: false,
}

export default ReviewCardHeader
